var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { IdOutskirtBuildings } from "../../../constants/IdOutskirtBuildings";
import { IdResource } from "../../../constants/IdResource";
import { selectInventoryResourceInfo } from "../../../selectors/selectInventoryInfo";
import { selectPlayerInfo } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionAddPelletsInScreenCenterAnimation } from "../../animation/actionPelletAnimations";
import { getResourceIconInfo } from "../../generic/icon/getResourceIconInfo";
import { actionInventoryInfoUpdateResource } from "../../info/inventory/actionInventoryInfo";
import { actionOutskirtsInfoUpdate } from "../../info/outskirts/actionOutskirtsInfo";
import { TypeActionDoghouse } from "../actionDoghouse";
export var epicDoghouseExchangeFreeTreats = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionDoghouse.RequestExchangeFreeTreats), switchMap(function (action) {
        var state = state$.value;
        var amount = action.amount;
        var playerId = selectPlayerInfo(state).playerId;
        return deps.netSend({
            id: CommandCode.ExchangeFreeTreatPoints,
            props: {
                amount: amount,
                playerId: playerId,
            },
        });
    }), retry(), switchMap(function (res) {
        var actions = [];
        if (res.dogOutSkirt != undefined) {
            var outskirtInfo = __assign({ amount: 0 }, res.dogOutSkirt);
            actions.push(actionOutskirtsInfoUpdate(outskirtInfo));
        }
        if (res.product != undefined) {
            var state = state$.value;
            var ownedAmount = selectInventoryResourceInfo(state, res.product.typeId || IdResource.DogtreatPremium).amount;
            var amount = (res.product.amount || ownedAmount.add(1)).subtract(ownedAmount);
            var iconInfo = getResourceIconInfo(__assign({}, res.product, { amount: amount }));
            actions.push(actionInventoryInfoUpdateResource([res.product]), actionAddPelletsInScreenCenterAnimation(IdOutskirtBuildings.Doghouse, [
                iconInfo,
            ]));
        }
        return from(actions);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/epics/epicDoghouseExchangeFreeTreats.ts
// module id = 1835
// module chunks = 3